var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgCard = function SvgCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M53.3742 17H10.6259C9.72794 17 9 17.7279 9 18.6258V45.0394C9 45.9373 9.72794 46.6652 10.6259 46.6652H53.3742C54.2721 46.6652 55 45.9373 55 45.0394V18.6258C55 17.7279 54.2721 17 53.3742 17Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3742 18H11.6259C10.7279 18 10 18.7279 10 19.6258V46.0394C10 46.9373 10.7279 47.6652 11.6259 47.6652H54.3742C55.2721 47.6652 56 46.9373 56 46.0394V19.6258C56 18.7279 55.2721 18 54.3742 18Z",
    fill: "#27A2DB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56 21.9653H10V26.3671H56V21.9653Z",
    fill: "#3A556A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3408 29.8745H13.0044V31.5472H25.3408V29.8745Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2942 34.6235H13.0044V36.2963H28.2942V34.6235Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0744 39.6045H13.0044V41.2772H31.0744V39.6045Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2138 44.4666C46.7891 44.4666 48.0662 43.1895 48.0662 41.6142C48.0662 40.0388 46.7891 38.7617 45.2138 38.7617C43.6384 38.7617 42.3613 40.0388 42.3613 41.6142C42.3613 43.1895 43.6384 44.4666 45.2138 44.4666Z",
    fill: "#E56353"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1942 44.4666C51.7696 44.4666 53.0467 43.1895 53.0467 41.6142C53.0467 40.0388 51.7696 38.7617 50.1942 38.7617C48.6189 38.7617 47.3418 40.0388 47.3418 41.6142C47.3418 43.1895 48.6189 44.4666 50.1942 44.4666Z",
    fill: "#FCD462"
  })));
};

export default __webpack_public_path__ + "static/media/card.a26dbe89.svg";
export { SvgCard as ReactComponent };